module.exports = __webpack_public_path__ + "fonts/source-code-pro-v22-latin-300.dfc97608.woff";